export const footer = () => {

    const toggleElementClass = '.js-toggle-info-content';
    const contentElementClass = 'footer__cols-info-content';
    const hideTitleElementClass = 'footer__cols-info-title--hidden';
    const hideContentElementClass = 'footer__cols-info-content--hidden';

    const footerColsTitles = document.querySelectorAll(toggleElementClass);

    footerColsTitles.forEach((title) => {
        title.addEventListener('click', () => {
            const windowWidth = window.innerWidth;
            if (windowWidth < 768) {
                if (title.nextElementSibling && title.nextElementSibling.classList.contains(contentElementClass)) {
                    let footerColsContent = title.nextElementSibling;
                    toggleElement(title, footerColsContent);
                }
            }
        });
    });

    function toggleElement(title, content) {
        title.classList.toggle(hideTitleElementClass);
        content.classList.toggle(hideContentElementClass);
    }
}